export default "__VITE_ASSET__CqsIHXBQ__"